import React from 'react'

function Loader() {
    return (
        <div className="loader">
            <li className="ball">L</li>
            <li className="ball">O</li>
            <li className="ball">A</li>
            <li className="ball">D</li>
            <li className="ball">I</li>
            <li className="ball">N</li>
            <li className="ball">G</li>
        </div >
    );
}

export default Loader